export default "/images/logo-15.png?b8b0a86c9a1fdd924d83e4568e2140b8";